var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inject } from "@angular/core";
import { AuthenticationVoData, CheckUtils, EncryptStorage, OrganizationModel } from "../..";
import { StorageData } from "../../storage/storage-data";
import { StorageType } from "../../storage/storage-type";
import { Events } from "ionic-angular";
import { SimpleModel } from "../simpleModel";
var AuthenticationModel = /** @class */ (function (_super) {
    __extends(AuthenticationModel, _super);
    function AuthenticationModel(storage, events, _organizationModel) {
        var _this = _super.call(this, storage, events, "authentication-user") || this;
        _this._organizationModel = _organizationModel;
        _this.__model = new AuthenticationVoData();
        _this.event.COOKIE_LOADED = _this._keyItem + "-cookie:loaded";
        _this.event.COOKIE_CHANGED = _this._keyItem + "-cookie:changed";
        _this.event.COOKIE_DELETED = _this._keyItem + "-cookie:deleted";
        _this.event.USER_ID_CHANGED = _this._keyItem + "-user-id:changed";
        _this.event.TOKEN_LOADED = _this._keyItem + "-token:loaded";
        _this.event.TOKEN_CHANGED = _this._keyItem + "-token:changed";
        _this.event.JID_CHANGED = _this._keyItem + "-jid:changed";
        return _this;
    }
    Object.defineProperty(AuthenticationModel.prototype, "_model", {
        get: function () {
            return this.__model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationModel.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationModel.prototype.loadData = function () {
        var _this = this;
        this.storage.load("authentication-token-" + this._organizationModel.uri, false, StorageType.SESSION).then(function (res) {
            _this.storage.load("login", false, StorageType.COOKIE).then(function (res) {
                _this._cookie = res;
                _this.events.publish(_this.event.COOKIE_LOADED, _this._cookie);
            });
            _this.events.publish(_this.event.TOKEN_LOADED, res);
        });
    };
    Object.defineProperty(AuthenticationModel.prototype, "userId", {
        get: function () {
            return this._model.uid;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationModel.prototype.setUserId = function (value, preventDefault, preventSave) {
        this._model.uid = value;
        var storageData = new StorageData(this.event.USER_ID_CHANGED, preventDefault, value);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    Object.defineProperty(AuthenticationModel.prototype, "cookie", {
        get: function () {
            return this._cookie;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationModel.prototype.setCookie = function (value, preventDefault) {
        this._cookie = value;
        if (CheckUtils.isEmpty(this._cookie)) {
            var storageData_1 = new StorageData(this.event.COOKIE_DELETED, preventDefault);
            storageData_1.key = "login";
            storageData_1.storageType = StorageType.COOKIE;
            return this.storage.delete(storageData_1);
        }
        var storageData = new StorageData(this.event.COOKIE_CHANGED, preventDefault, value, false, StorageType.COOKIE);
        storageData.item = value;
        storageData.key = "login";
        storageData.encrypt = false;
        return this.storage.saveAs(storageData);
    };
    Object.defineProperty(AuthenticationModel.prototype, "authenticationToken", {
        get: function () {
            return this._authenticationToken;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationModel.prototype.setAuthenticationToken = function (value, preventDefault) {
        var storageData = new StorageData(this.event.TOKEN_CHANGED, preventDefault, value, false, StorageType.SESSION);
        storageData.item = value;
        storageData.key = "authentication-token-" + this._organizationModel.uri;
        storageData.encrypt = false;
        if (value == null)
            return this.storage.delete(storageData);
        if (this._authenticationToken == value)
            return false;
        this._authenticationToken = value;
        return this.storage.saveAs(storageData);
    };
    Object.defineProperty(AuthenticationModel.prototype, "jid", {
        get: function () {
            return this._model.jid;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationModel.prototype.setJid = function (value, preventDefault) {
        if (this._model.jid == value)
            return false;
        this._model.jid = value;
        return this.save(new StorageData(this.event.JID_CHANGED, preventDefault, value));
    };
    AuthenticationModel.prototype.clear = function (preventDefault, preventSave) {
        this._authenticationToken = null;
        this._model.uid = null;
        this._model.jid = null;
        var storageData = new StorageData(this.event.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    AuthenticationModel.prototype.clone = function () {
        var clone = new AuthenticationVoData();
        clone.uid = this._model.uid;
        clone.jid = this._model.jid;
        return clone;
    };
    /** @nocollapse */
    AuthenticationModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
        { type: OrganizationModel, decorators: [{ type: Inject, args: [OrganizationModel,] },] },
    ]; };
    return AuthenticationModel;
}(SimpleModel));
export { AuthenticationModel };
//# sourceMappingURL=authentication-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/authentication/authentication-model.js
// module id = 350
// module chunks = 14